import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "meeting-header__text" }
const _hoisted_2 = { class: "meeting-header__title" }
const _hoisted_3 = { class: "congrats-body" }
const _hoisted_4 = { class: "congrats-message" }
const _hoisted_5 = { class: "congrats-question" }
const _hoisted_6 = { class: "modal-footer-buttons" }
const _hoisted_7 = { class: "modal-body-content" }
const _hoisted_8 = { class: "title-card" }
const _hoisted_9 = { class: "title-card__content" }
const _hoisted_10 = { class: "title-card__avatar" }
const _hoisted_11 = { class: "title-card__info" }
const _hoisted_12 = { class: "title-card__name" }
const _hoisted_13 = { class: "title-card__badge" }
const _hoisted_14 = { class: "title-card__actions" }
const _hoisted_15 = {
  key: 0,
  class: "title-card__url-row"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "details-section" }
const _hoisted_18 = { class: "detail-row" }
const _hoisted_19 = { class: "detail-label-group" }
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = { class: "detail-label-group" }
const _hoisted_22 = { class: "detail-row" }
const _hoisted_23 = {
  key: 0,
  class: "detail-value"
}
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = {
  key: 0,
  class: "detail-value"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "detail-row" }
const _hoisted_28 = { class: "detail-value" }
const _hoisted_29 = { class: "detail-row" }
const _hoisted_30 = { class: "detail-value" }
const _hoisted_31 = { class: "detail-row" }
const _hoisted_32 = { class: "detail-value" }
const _hoisted_33 = { class: "detail-row" }
const _hoisted_34 = {
  key: 0,
  class: "detail-value"
}
const _hoisted_35 = { class: "detail-row" }
const _hoisted_36 = { class: "detail-row" }
const _hoisted_37 = { class: "detail-value" }
const _hoisted_38 = {
  key: 0,
  class: "guests-section"
}
const _hoisted_39 = { class: "guests-section__header" }
const _hoisted_40 = {
  key: 0,
  class: "guests-section__count"
}
const _hoisted_41 = {
  key: 0,
  class: "guests-section__loading"
}
const _hoisted_42 = {
  key: 1,
  class: "guests-section__list"
}
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = { class: "guest-card__info" }
const _hoisted_45 = { class: "guest-card__name" }
const _hoisted_46 = {
  key: 0,
  class: "guest-card__email"
}
const _hoisted_47 = { class: "guest-card__status-text" }
const _hoisted_48 = {
  key: 2,
  class: "guests-section__list"
}
const _hoisted_49 = ["src", "alt"]
const _hoisted_50 = {
  key: 1,
  class: "guest-card__avatar guest-card__avatar--needsAction"
}
const _hoisted_51 = { class: "guest-card__info" }
const _hoisted_52 = { class: "guest-card__email" }
const _hoisted_53 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_54 = { class: "detail-row" }
const _hoisted_55 = {
  key: 0,
  class: "detail-value"
}
const _hoisted_56 = ["href"]
const _hoisted_57 = { class: "note-section" }
const _hoisted_58 = { class: "note-section__header" }
const _hoisted_59 = { class: "note-section__actions" }
const _hoisted_60 = { class: "note-section__footer" }
const _hoisted_61 = { class: "modal-footer-actions" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { useToast } from "@/composables/ui/useToast";
import { useStore } from "vuex";
import { Clipboard } from "v-clipboard";
import { Modal, Button, Icon, PopoverMenu } from "@/components/ui";
import NotesModal from "@/components/note/NotesModal.vue";
import EditMeetingTitleModal from "@/components/meeting/EditMeetingTitleModal.vue";
import BookMeetingModal from "@/components/meeting/BookMeetingModal.vue";
import DeleteConfirmationModal from "@/components/modal/DeleteConfirmationModal.vue";
import CreateOpportunityModal from "@/components/opportunity/CreateOpportunityModal.vue";
import LastInteractionModal from "@/components/bucket/LastInteractionModal.vue";
import AddBucketModal from "@/components/bucket/AddBucketModal.vue";
import LinkedInProfileViewerModal from "@/components/bucket/linkedin/LinkedInProfileViewerModal.vue";
import CompanyProfileViewerModal from "@/components/bucket/company/CompanyProfileViewerModal.vue";
import filters from "@/utils/filters";
import { CONTACT_OVERVIEW_ROUTE, BUCKETS_ROUTE, COMPANY_OVERVIEW_ROUTE } from "@/router/routes";
import { MeetingStatuses, BucketFollowUpState } from "@/utils/enums";
import { useEditMeeting, useDeleteMeeting, useMeetingAttendees } from "@/composables/meetings";
import { useDeleteBucket, useBucketOptions, useBuckets } from "@/composables/bucket";
import { useRegisterNote } from "@/composables/notes";
import { useChannelManager } from "@/composables/task-followup/useChannelManager";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'MeetingDetailsModal',
  props: {
    selectedMeeting: {}
  },
  emits: ["closeMeetingDetailsModal", "refreshMeetings"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

const $toast = useToast();

// Store (only for account)
const store = useStore();
const account = computed(() => store.getters.account.data);

// Bucket options for name lookup
const bucketOptionsParams = computed(() =>
  account.value?.organizationId ? { organizationId: account.value.organizationId } : null
);
const { data: bucketOptionsData } = useBucketOptions(bucketOptionsParams);

// Contact's current bucket record (meetings API does not nest bucketOption)
const contactBucketParams = computed(() => {
  const contactId = props.selectedMeeting?.contact?.id ?? props.selectedMeeting?.contactId ?? null;
  if (!account.value?.organizationId || !contactId) return null;
  return { organizationId: account.value.organizationId, contactId };
});
const { data: contactBucketData } = useBuckets(contactBucketParams);
const existingContactBucket = computed(() => {
  const data = contactBucketData.value as any;
  return data?.data?.[0] ?? null;
});

// Mutations
const editMeetingMutation = useEditMeeting();
const deleteMeetingMutation = useDeleteMeeting();
const removeBucketMutation = useDeleteBucket();
const registerNoteMutation = useRegisterNote();

// Attendees RSVP
const meetingId = computed(() => props.selectedMeeting?.id);
const {
  attendees,
  isLoading: isLoadingAttendees,
  refetch: refetchAttendees,
} = useMeetingAttendees(meetingId);

// Guests are calendar attendees (email/displayName only) and aren't linked to a Contact
// record themselves — but the meeting's own primary contact is already loaded here, so
// a guest whose email matches that contact's email can reuse its profilePictureUrl with
// no extra request instead of falling back to the initial-letter avatar.
const meetingContact = computed(() => props.selectedMeeting?.contact ?? null);
const meetingContactEmails = computed(() => {
  const contact = meetingContact.value;
  if (!contact) return [];
  return [contact.email, ...(contact.additionalEmails || [])]
    .filter(Boolean)
    .map((email: string) => email.toLowerCase());
});

const guestProfilePicture = (email: string | undefined | null) => {
  if (!email || !meetingContact.value?.profilePictureUrl) return null;
  return meetingContactEmails.value.includes(email.toLowerCase())
    ? meetingContact.value.profilePictureUrl
    : null;
};

const rsvpBadgeClass = (status: string) => {
  switch (status) {
    case "accepted":
      return "rsvp-badge--accepted";
    case "declined":
      return "rsvp-badge--declined";
    case "tentative":
      return "rsvp-badge--tentative";
    default:
      return "rsvp-badge--awaiting";
  }
};

const rsvpLabel = (status: string) => {
  switch (status) {
    case "accepted":
      return "Accepted";
    case "declined":
      return "Declined";
    case "tentative":
      return "Tentative";
    default:
      return "Awaiting";
  }
};

const rsvpIcon = (status: string) => {
  switch (status) {
    case "accepted":
      return "mdi:check-circle-outline";
    case "declined":
      return "mdi:close-circle-outline";
    case "tentative":
      return "mdi:help-circle-outline";
    default:
      return "mdi:clock-outline";
  }
};

const rsvpStatusText = (status: string) => {
  switch (status) {
    case "accepted":
      return "Accepted the invite";
    case "declined":
      return "Declined the invite";
    case "tentative":
      return "Tentatively accepted";
    default:
      return "Hasn't responded yet";
  }
};

// LinkedIn channel
const { linkedInChannel, loadChannels } = useChannelManager($toast);

const openLinkedInProfileModal = () => {
  if (!linkedInChannel.value) {
    $toast.error("LinkedIn account not connected. Please connect it in Settings → Integrations.");
    return;
  }
  showLinkedInProfileModal.value = true;
};

const openCompanyProfileModal = () => {
  if (!linkedInChannel.value) {
    $toast.error("LinkedIn account not connected. Please connect it in Settings → Integrations.");
    return;
  }
  showCompanyProfileModal.value = true;
};

// State
const showModal = ref(true);
const showNotesModal = ref(false);
const showEditMeetingModal = ref(false);
const showDeleteConfirmationModal = ref(false);
const showCreateOpportunityModal = ref(false);
const showLastInteractionModal = ref(false);
const showLinkedInProfileModal = ref(false);
const showCompanyProfileModal = ref(false);
const showRescheduleModal = ref(false);
const showRescheduleMeetingModal = ref(false);
const showCongratulationsModal = ref(false);
const selectedContact = ref<any>(null);
const noteText = ref("");
const isUpdatingStatus = ref(false);
const updatingStatusType = ref<string | null>(null);
const currentMeetingStatus = ref<string>(MeetingStatuses.pending);

// Computed
const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const deviceTimeZoneOffset = computed(() => {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offsetMinutes) / 60);
  const offsetMins = Math.abs(offsetMinutes) % 60;
  const sign = offsetMinutes <= 0 ? "+" : "-";
  return `GMT${sign}${String(offsetHours).padStart(2, "0")}${offsetMins ? ":" + String(offsetMins).padStart(2, "0") : ""}`;
});

const isRegisteringNote = computed(() => registerNoteMutation.isPending.value);

const normalizedStatus = (status: string | undefined) => {
  if (!status) return MeetingStatuses.pending;
  const s = (status || "").toLowerCase().replace(/_/g, "-");
  if (s === "no-show" || s === "noshow") return MeetingStatuses.noShow;
  if (s === "meeting-held" || s === "meetingheld") return MeetingStatuses.meetingHeld;
  return MeetingStatuses.pending;
};

const isNoShow = computed(() => currentMeetingStatus.value === MeetingStatuses.noShow);
const isMeetingHeld = computed(() => currentMeetingStatus.value === MeetingStatuses.meetingHeld);

const meetingStatusIcons: Record<string, string> = {
  [MeetingStatuses.noShow]: "lucide:user-x",
  [MeetingStatuses.meetingHeld]: "mdi:calendar-check",
};

const meetingContactId = computed(() => {
  const m = props.selectedMeeting;
  return m?.contact?.id ?? m?.contactId ?? "";
});

const meetingContactFullName = computed(() => {
  const contact = props.selectedMeeting?.contact;
  if (!contact) return "the contact";
  const fname = capitalize(contact.fname) || contact.fname || "";
  const lname = capitalize(contact.lname) || contact.lname || "";
  return `${fname} ${lname}`.trim() || "the contact";
});

const meetingBucketName = computed(() => {
  const bucket = existingContactBucket.value;
  if (!bucket) return null;
  const bucketOptionId = bucket.bucketOptionId;
  if (!bucketOptionId || !bucketOptionsData.value) return null;
  const option = (bucketOptionsData.value as any[]).find((o: any) => o.id === bucketOptionId);
  return option?.name ?? null;
});

const meetingBucketSlug = computed(() => {
  const bucket = existingContactBucket.value;
  if (!bucket) return null;
  const bucketOptionId = bucket.bucketOptionId;
  if (!bucketOptionId || !bucketOptionsData.value) return null;
  const option = (bucketOptionsData.value as any[]).find((o: any) => o.id === bucketOptionId);
  return option?.slug ?? null;
});

const meetingBucketColorHex = computed(() => {
  const bucket = existingContactBucket.value;
  if (!bucket?.bucketOptionId || !bucketOptionsData.value) return null;
  const option = (bucketOptionsData.value as any[]).find(
    (o: any) => o.id === bucket.bucketOptionId
  );
  return option?.colorHex ?? null;
});

const meetingBucketFollowUpState = computed((): BucketFollowUpState => {
  const bucket = existingContactBucket.value;
  if (!bucket?.followUpDate) return BucketFollowUpState.past;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const followUp = new Date(bucket.followUpDate);
  followUp.setHours(0, 0, 0, 0);
  if (followUp < today) return BucketFollowUpState.past;
  if (followUp.getTime() === today.getTime()) return BucketFollowUpState.due;
  return BucketFollowUpState.future;
});

const meetingCompanyName = computed(() => props.selectedMeeting?.contact?.company?.name ?? null);
const meetingCompanyId = computed(() => props.selectedMeeting?.contact?.company?.id ?? null);
const meetingJobTitle = computed(() => props.selectedMeeting?.contact?.jobTitle ?? null);
const meetingCompanyLinkedInUrl = computed(
  () => props.selectedMeeting?.contact?.company?.linkedInUrl ?? null
);

const contactLinkedInBucket = computed(() => ({
  contact: {
    linkedInUrl: props.selectedMeeting?.contact?.linkedInUrl,
    fname: props.selectedMeeting?.contact?.fname,
    lname: props.selectedMeeting?.contact?.lname,
    contactId: props.selectedMeeting?.contact?.id,
    profilePictureUrl: props.selectedMeeting?.contact?.profilePictureUrl ?? null,
  },
}));

const companyLinkedInBucket = computed(() => ({
  contact: {
    company: {
      linkedInUrl: props.selectedMeeting?.contact?.company?.linkedInUrl,
      name: props.selectedMeeting?.contact?.company?.name,
      companyId: props.selectedMeeting?.contact?.company?.id,
      logoUrl: props.selectedMeeting?.contact?.company?.logoUrl ?? null,
    },
  },
}));

const meetingType = computed(() => {
  const url = props.selectedMeeting?.meetingURL ?? "";
  if (url.includes("zoom.us")) return "Zoom Meeting";
  if (url.includes("meet.google.com")) return "Google Meet";
  if (url.includes("teams.microsoft.com")) return "Microsoft Teams";
  return "Video Meeting";
});

const joinMeeting = () => {
  if (props.selectedMeeting?.meetingURL) {
    window.open(props.selectedMeeting.meetingURL, "_blank", "noopener,noreferrer");
  }
};

// Filter helper functions
const capitalize = (value: string | undefined) => {
  return filters.capitalize(value ?? "") || value || "";
};

const getTimeOnly = (value: string | undefined) => {
  return filters.getTimeOnly(value ?? "") || value || "";
};

const getDateOnly = (value: string | undefined) => {
  return filters.getDateOnly(value ?? "") || value || "";
};

const popoverMenuItems = computed(() => [
  {
    label: "Edit Meeting Title",
    icon: "mdi:pencil-outline",
    onClick: () => {
      showEditMeetingModal.value = true;
    },
  },
  {
    label: "Reschedule Meeting",
    icon: "mdi:calendar-clock",
    onClick: () => {
      showRescheduleMeetingModal.value = true;
    },
  },
  {
    label: "Delete",
    icon: "mdi:trash-can-outline",
    onClick: () => {
      showDeleteConfirmationModal.value = true;
    },
  },
]);

// Methods
const closeModal = () => {
  emit("closeMeetingDetailsModal");
};

const copyToClipboard = (value: string) => {
  Clipboard.copy(value);
  $toast?.info?.("Copied to clipboard");
};

const showContactNotes = () => {
  selectedContact.value = props.selectedMeeting.contact;
  showNotesModal.value = true;
};

const refreshMeeting = (meeting: any) => {
  props.selectedMeeting.title = meeting.title;
};

const handleRescheduleMeetingSave = (meeting: any) => {
  if (meeting?.meetingDateTime) {
    props.selectedMeeting.meetingDateTime = meeting.meetingDateTime;
  }
  if (meeting?.duration) {
    props.selectedMeeting.duration = meeting.duration;
  }
  if (meeting?.meetingURL) {
    props.selectedMeeting.meetingURL = meeting.meetingURL;
  }
  showRescheduleMeetingModal.value = false;
  emit("refreshMeetings");
};

const handleNoShow = async () => {
  if (isNoShow.value) {
    await editMeetingStatus(MeetingStatuses.pending);
    return;
  }
  if (!meetingContactId.value) {
    await editMeetingStatus(MeetingStatuses.noShow);
    return;
  }
  showRescheduleModal.value = true;
};

const handleRescheduleSave = async () => {
  showRescheduleModal.value = false;
  await editMeetingStatus(MeetingStatuses.noShow);
  if (currentMeetingStatus.value === MeetingStatuses.noShow) {
    $toast?.success?.("Meeting marked as No Show");
  }
};

const handleMeetingHeld = async () => {
  if (isMeetingHeld.value) {
    await editMeetingStatus(MeetingStatuses.pending);
    return;
  }
  showCongratulationsModal.value = true;
};

const handleCongratulationsYes = async () => {
  showCongratulationsModal.value = false;
  await editMeetingStatus(MeetingStatuses.meetingHeld);
  if (currentMeetingStatus.value === MeetingStatuses.meetingHeld) {
    showCreateOpportunityModal.value = true;
  }
};

const handleCongratulationsNo = async () => {
  showCongratulationsModal.value = false;
  await editMeetingStatus(MeetingStatuses.meetingHeld);
};

const editMeetingStatus = async (status: string) => {
  isUpdatingStatus.value = true;
  updatingStatusType.value = status;

  try {
    await editMeetingMutation.mutateAsync({
      id: props.selectedMeeting.id,
      status: status,
    } as any);

    currentMeetingStatus.value = status;
    emit("refreshMeetings");
  } catch (error: any) {
    $toast?.error?.(error?.message || "Failed to update meeting status");
  } finally {
    isUpdatingStatus.value = false;
    updatingStatusType.value = null;
  }
};

const handleRegisterNote = async () => {
  if (!noteText.value?.trim()) return;

  try {
    await registerNoteMutation.mutateAsync({
      message: noteText.value,
      contactId: props.selectedMeeting.contactId,
      organizationId: account.value?.organizationId,
    });
    noteText.value = "";
  } catch {}
};

const handleDeleteMeeting = async () => {
  if (!props.selectedMeeting?.id) {
    return { success: false, message: "No meeting selected" };
  }

  try {
    await deleteMeetingMutation.mutateAsync(props.selectedMeeting.id);
    $toast?.success?.("Meeting deleted successfully");
    return true;
  } catch (error: any) {
    const errorMessage = error?.message || "Failed to delete meeting";
    $toast?.error?.(errorMessage);
    return false;
  }
};

const handleDeleteSuccess = () => {
  emit("refreshMeetings");
  closeModal();
};

const handleCloseOpportunityModal = () => {
  showCreateOpportunityModal.value = false;
};

const handleOpportunityCreated = async () => {
  const bucketId = existingContactBucket.value?.id;
  if (bucketId) {
    try {
      await removeBucketMutation.mutateAsync(bucketId);
    } catch (error: any) {
      $toast?.error?.(error?.message || "Failed to remove contact from bucket");
    }
  }
  emit("refreshMeetings");
  showCreateOpportunityModal.value = false;
  closeModal();
};

watch(
  () => props.selectedMeeting?.status,
  (status) => {
    currentMeetingStatus.value = normalizedStatus(status);
  },
  { immediate: true }
);

// Real-time RSVP updates via custom event from notification store
const onRsvpUpdated = (e: Event) => {
  const detail = (e as CustomEvent).detail;
  if (detail?.meetingId === props.selectedMeeting?.id) {
    refetchAttendees();
  }
};

onMounted(() => {
  currentMeetingStatus.value = normalizedStatus(props.selectedMeeting?.status);
  window.addEventListener("rsvp-updated", onRsvpUpdated);
  loadChannels();
});

onBeforeUnmount(() => {
  window.removeEventListener("rsvp-updated", onRsvpUpdated);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Modal), {
    show: showModal.value,
    size: "md",
    onClose: closeModal,
    headerVariant: "blue",
    blurBackdrop: false,
    backdropOpacity: 0.5,
    "show-close-button": false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.selectedMeeting?.title || "Meeting Details"), 1),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "meeting-header__subtitle" }, "View meeting details", -1))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "meeting-header__close",
        onClick: closeModal,
        "aria-label": "Close"
      }, [
        _createVNode(_unref(Icon), {
          icon: "mdi:close",
          width: "18",
          height: "18"
        })
      ])
    ]),
    default: _withCtx(() => [
      (showNotesModal.value)
        ? (_openBlock(), _createBlock(NotesModal, {
            key: 0,
            selectedContact: selectedContact.value,
            onCloseNotesModal: _cache[0] || (_cache[0] = ($event: any) => (showNotesModal.value = false))
          }, null, 8, ["selectedContact"]))
        : _createCommentVNode("", true),
      (showEditMeetingModal.value)
        ? (_openBlock(), _createBlock(EditMeetingTitleModal, {
            key: 1,
            selectedMeeting: __props.selectedMeeting,
            onCloseEditMeetingModal: _cache[1] || (_cache[1] = ($event: any) => (showEditMeetingModal.value = false)),
            onRefreshMeeting: refreshMeeting
          }, null, 8, ["selectedMeeting"]))
        : _createCommentVNode("", true),
      (showDeleteConfirmationModal.value)
        ? (_openBlock(), _createBlock(DeleteConfirmationModal, {
            key: 2,
            deleteFunction: handleDeleteMeeting,
            entity: "Meeting",
            plural: false,
            onCloseDeleteConfirmationModal: _cache[2] || (_cache[2] = ($event: any) => (showDeleteConfirmationModal.value = false)),
            onRefreshRecords: handleDeleteSuccess
          }))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showCreateOpportunityModal.value)
          ? (_openBlock(), _createBlock(CreateOpportunityModal, {
              key: 0,
              contactId: __props.selectedMeeting?.contactId,
              initialLeadSourceId: __props.selectedMeeting?.leadSourceId,
              showProducts: true,
              showNotes: true,
              showHeaderCard: true,
              onCloseModal: handleCloseOpportunityModal,
              onOpportunityCreated: handleOpportunityCreated
            }, null, 8, ["contactId", "initialLeadSourceId"]))
          : _createCommentVNode("", true)
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showRescheduleMeetingModal.value)
          ? (_openBlock(), _createBlock(BookMeetingModal, {
              key: 0,
              selectedMeeting: __props.selectedMeeting,
              onCloseBookMeetingModal: _cache[3] || (_cache[3] = ($event: any) => (showRescheduleMeetingModal.value = false)),
              onMeetingRescheduled: handleRescheduleMeetingSave
            }, null, 8, ["selectedMeeting"]))
          : _createCommentVNode("", true)
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showRescheduleModal.value)
          ? (_openBlock(), _createBlock(AddBucketModal, {
              key: 0,
              contactIds: [meetingContactId.value],
              title: "Reschedule",
              subtitle: "Assign contact to a bucket",
              onCloseAddBucketModal: _cache[4] || (_cache[4] = ($event: any) => (showRescheduleModal.value = false)),
              onRefreshBuckets: handleRescheduleSave
            }, null, 8, ["contactIds"]))
          : _createCommentVNode("", true)
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showCongratulationsModal.value)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 0,
              show: showCongratulationsModal.value,
              size: "sm",
              onClose: _cache[6] || (_cache[6] = ($event: any) => (showCongratulationsModal.value = false)),
              closeOnBackdrop: false,
              blurBackdrop: false,
              backdropOpacity: 0.5,
              "show-close-button": false,
              headerVariant: "blue"
            }, {
              header: _withCtx(() => [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "meeting-header__text" }, [
                  _createElementVNode("h2", { class: "meeting-header__title" }, "Congratulations! 🎉")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "meeting-header__close",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showCongratulationsModal.value = false)),
                  "aria-label": "Close"
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:close",
                    width: "18",
                    height: "18"
                  })
                ])
              ]),
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Button), {
                    type: "button",
                    variant: "secondary",
                    size: "md",
                    onClick: handleCongratulationsNo,
                    disabled: isUpdatingStatus.value
                  }, {
                    default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                      _createTextVNode(" No ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_unref(Button), {
                    type: "button",
                    variant: "primary",
                    size: "md",
                    onClick: handleCongratulationsYes,
                    loading: isUpdatingStatus.value,
                    disabled: isUpdatingStatus.value
                  }, {
                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                      _createTextVNode(" Yes ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "congrats-icon" }, "🎉", -1)),
                  _createElementVNode("p", _hoisted_4, [
                    _cache[20] || (_cache[20] = _createTextVNode(" Congratulations on having a meeting with ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(meetingContactFullName.value), 1),
                    _cache[21] || (_cache[21] = _createTextVNode("! ", -1))
                  ]),
                  _createElementVNode("p", _hoisted_5, [
                    _cache[23] || (_cache[23] = _createTextVNode(" Do you want to create an opportunity ", -1)),
                    (meetingBucketName.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[22] || (_cache[22] = _createTextVNode(" and remove this contact from ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(meetingBucketName.value), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[24] || (_cache[24] = _createTextVNode("? ", -1))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true)
      ])),
      (showLastInteractionModal.value && meetingContactId.value)
        ? (_openBlock(), _createBlock(LastInteractionModal, {
            key: 3,
            "contact-id": meetingContactId.value,
            "contact-email": __props.selectedMeeting?.contact?.email || '',
            onCloseLastInteractionModal: _cache[7] || (_cache[7] = ($event: any) => (showLastInteractionModal.value = false))
          }, null, 8, ["contact-id", "contact-email"]))
        : _createCommentVNode("", true),
      _createVNode(LinkedInProfileViewerModal, {
        show: showLinkedInProfileModal.value,
        selectedBucket: contactLinkedInBucket.value,
        linkedInChannel: _unref(linkedInChannel),
        onClose: _cache[8] || (_cache[8] = ($event: any) => (showLinkedInProfileModal.value = false))
      }, null, 8, ["show", "selectedBucket", "linkedInChannel"]),
      _createVNode(CompanyProfileViewerModal, {
        show: showCompanyProfileModal.value,
        selectedBucket: companyLinkedInBucket.value,
        linkedInChannel: _unref(linkedInChannel),
        onClose: _cache[9] || (_cache[9] = ($event: any) => (showCompanyProfileModal.value = false))
      }, null, 8, ["show", "selectedBucket", "linkedInChannel"]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Icon), {
                icon: "mdi:video-outline",
                class: "title-card__avatar-icon"
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h5", _hoisted_12, _toDisplayString(__props.selectedMeeting.title), 1),
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:video",
                  width: "11",
                  height: "11"
                }),
                _createTextVNode(" " + _toDisplayString(meetingType.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (__props.selectedMeeting.meetingURL)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    variant: "primary",
                    size: "sm",
                    icon: "mdi:video-outline",
                    onClick: joinMeeting
                  }, {
                    default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                      _createTextVNode(" Join Now → ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(PopoverMenu), {
                items: popoverMenuItems.value,
                placement: "bottom"
              }, null, 8, ["items"])
            ])
          ]),
          (__props.selectedMeeting.meetingURL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:open-in-new",
                  class: "title-card__url-icon"
                }),
                _createElementVNode("a", {
                  class: "title-card__url",
                  href: __props.selectedMeeting.meetingURL,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(__props.selectedMeeting.meetingURL), 9, _hoisted_16),
                _createElementVNode("button", {
                  type: "button",
                  class: "title-card__copy-btn",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (copyToClipboard(__props.selectedMeeting.meetingURL)))
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:content-copy",
                    width: "14",
                    height: "14"
                  }),
                  _cache[29] || (_cache[29] = _createTextVNode(" Copy ", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "detail-label" }, "Contact Name", -1)),
              (__props.selectedMeeting.contact?.linkedInUrl)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "linkedin-view-btn",
                    onClick: openLinkedInProfileModal,
                    title: "View LinkedIn profile"
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:linkedin",
                      class: "linkedin-view-icon"
                    }),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "linkedin-view-text" }, "View", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, {
              to: {
                name: _unref(CONTACT_OVERVIEW_ROUTE),
                params: { id: __props.selectedMeeting.contact?.id },
              },
              class: "detail-value detail-value--link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(capitalize(__props.selectedMeeting.contact?.fname)) + " " + _toDisplayString(capitalize(__props.selectedMeeting.contact?.lname)), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "detail-label" }, "Company", -1)),
              (meetingCompanyLinkedInUrl.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "linkedin-view-btn",
                    onClick: openCompanyProfileModal,
                    title: "View LinkedIn company profile"
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:linkedin",
                      class: "linkedin-view-icon"
                    }),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "linkedin-view-text" }, "View", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (meetingCompanyId.value && meetingCompanyName.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: _unref(COMPANY_OVERVIEW_ROUTE), params: { id: meetingCompanyId.value } },
                  class: "detail-value detail-value--link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(meetingCompanyName.value), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "detail-label" }, "Job Title", -1)),
            (meetingJobTitle.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(meetingJobTitle.value), 1))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "detail-label" }, "LinkedIn Link", -1)),
            (__props.selectedMeeting.contact?.linkedInUrl)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                  _createElementVNode("a", {
                    class: "detail-value--link link-truncate",
                    href: __props.selectedMeeting.contact?.linkedInUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(__props.selectedMeeting.contact?.linkedInUrl), 9, _hoisted_26),
                  _createVNode(_unref(Icon), {
                    icon: "mdi:open-in-new",
                    class: "link-icon",
                    onClick: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                  }),
                  _createVNode(_unref(Icon), {
                    icon: "mdi:content-copy",
                    class: "link-icon",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (copyToClipboard(__props.selectedMeeting.contact?.linkedInUrl)), ["stop"]))
                  })
                ]))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[36] || (_cache[36] = _createElementVNode("span", { class: "detail-label" }, "Meeting Time", -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString(getTimeOnly(__props.selectedMeeting.meetingDateTime)), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _cache[37] || (_cache[37] = _createElementVNode("span", { class: "detail-label" }, "Time Zone", -1)),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(deviceTimeZone)) + " (" + _toDisplayString(deviceTimeZoneOffset.value) + ")", 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[38] || (_cache[38] = _createElementVNode("span", { class: "detail-label" }, "Meeting Date", -1)),
            _createElementVNode("span", _hoisted_32, _toDisplayString(getDateOnly(__props.selectedMeeting.meetingDateTime)), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[39] || (_cache[39] = _createElementVNode("span", { class: "detail-label" }, "Duration", -1)),
            (__props.selectedMeeting.duration)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(__props.selectedMeeting.duration) + " Minutes ", 1))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "detail-label" }, "Bucket", -1)),
            (meetingBucketName.value && meetingBucketSlug.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
                name: _unref(BUCKETS_ROUTE),
                params: { bucket: meetingBucketSlug.value },
                query: { status: meetingBucketFollowUpState.value, contactId: meetingContactId.value },
              },
                  class: "bucket-badge-link",
                  style: _normalizeStyle(meetingBucketColorHex.value ? { borderColor: meetingBucketColorHex.value } : {})
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "bucket-badge-link__name",
                      style: _normalizeStyle(meetingBucketColorHex.value ? { color: meetingBucketColorHex.value } : {})
                    }, _toDisplayString(meetingBucketName.value), 5),
                    _createElementVNode("span", {
                      class: _normalizeClass(["bucket-badge-link__state", `bucket-badge-link__state--${meetingBucketFollowUpState.value}`])
                    }, _toDisplayString(meetingBucketFollowUpState.value.charAt(0).toUpperCase() +
                  meetingBucketFollowUpState.value.slice(1)), 3)
                  ]),
                  _: 1
                }, 8, ["to", "style"]))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ]),
          _createElementVNode("div", _hoisted_36, [
            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "detail-label" }, "Booked Date", -1)),
            _createElementVNode("span", _hoisted_37, _toDisplayString(getDateOnly(__props.selectedMeeting.createdAt)), 1)
          ]),
          (
              _unref(isLoadingAttendees) || _unref(attendees).length > 0 || __props.selectedMeeting.guestEmails?.length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:account-group-outline",
                    class: "guests-section__icon"
                  }),
                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "guests-section__title" }, "Guests", -1)),
                  (_unref(attendees).length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_unref(attendees).length), 1))
                    : _createCommentVNode("", true)
                ]),
                (_unref(isLoadingAttendees))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:loading",
                        class: "spinner-icon"
                      }),
                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "Loading guests...", -1))
                    ]))
                  : (_unref(attendees).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attendees), (attendee) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: attendee.id,
                            class: "guest-card"
                          }, [
                            (guestProfilePicture(attendee.email))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: guestProfilePicture(attendee.email),
                                  alt: attendee.displayName || attendee.email,
                                  class: "guest-card__avatar-photo"
                                }, null, 8, _hoisted_43))
                              : (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass(["guest-card__avatar", 'guest-card__avatar--' + attendee.responseStatus])
                                }, _toDisplayString((attendee.displayName || attendee.email).charAt(0).toUpperCase()), 3)),
                            _createElementVNode("div", _hoisted_44, [
                              _createElementVNode("span", _hoisted_45, _toDisplayString(attendee.displayName || attendee.email), 1),
                              (attendee.displayName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(attendee.email), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_47, _toDisplayString(rsvpStatusText(attendee.responseStatus)), 1)
                            ]),
                            _createElementVNode("span", {
                              class: _normalizeClass(['rsvp-badge', rsvpBadgeClass(attendee.responseStatus)])
                            }, [
                              _createVNode(_unref(Icon), {
                                icon: rsvpIcon(attendee.responseStatus),
                                class: "rsvp-badge__icon"
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(rsvpLabel(attendee.responseStatus)), 1)
                            ], 2)
                          ]))
                        }), 128))
                      ]))
                    : (__props.selectedMeeting.guestEmails?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.selectedMeeting.guestEmails, (email, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "guest-card"
                            }, [
                              (guestProfilePicture(email))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: guestProfilePicture(email),
                                    alt: email,
                                    class: "guest-card__avatar-photo"
                                  }, null, 8, _hoisted_49))
                                : (_openBlock(), _createElementBlock("div", _hoisted_50, _toDisplayString(email.charAt(0).toUpperCase()), 1)),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, _toDisplayString(email), 1),
                                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "guest-card__status-text" }, "No tracking available", -1))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "detail-label" }, "Guests", -1)),
                _createVNode(_unref(Icon), {
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                })
              ])),
          _createElementVNode("div", _hoisted_54, [
            _cache[46] || (_cache[46] = _createElementVNode("span", { class: "detail-label" }, "Meeting Link", -1)),
            (__props.selectedMeeting.meetingURL)
              ? (_openBlock(), _createElementBlock("span", _hoisted_55, [
                  _createElementVNode("a", {
                    class: "detail-value--link link-truncate",
                    href: __props.selectedMeeting.meetingURL,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(__props.selectedMeeting.meetingURL), 9, _hoisted_56),
                  _createVNode(_unref(Icon), {
                    icon: "mdi:open-in-new",
                    class: "link-icon",
                    onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                  }),
                  _createVNode(_unref(Icon), {
                    icon: "mdi:content-copy",
                    class: "link-icon",
                    onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (copyToClipboard(__props.selectedMeeting.meetingURL)), ["stop"]))
                  })
                ]))
              : (_openBlock(), _createBlock(_unref(Icon), {
                  key: 1,
                  icon: "mdi:minus",
                  class: "detail-value--empty"
                }))
          ])
        ]),
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _cache[49] || (_cache[49] = _createElementVNode("label", { class: "note-section__label" }, "Add Note", -1)),
            _createElementVNode("div", _hoisted_59, [
              (meetingContactId.value)
                ? (_openBlock(), _createBlock(_unref(Button), {
                    key: 0,
                    variant: "secondary",
                    size: "sm",
                    icon: "mdi:message-text-clock-outline",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (showLastInteractionModal.value = true))
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode(" Last Interaction History ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(Button), {
                variant: "secondary",
                size: "sm",
                icon: "mdi:history",
                onClick: showContactNotes
              }, {
                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                  _createTextVNode(" Note History ", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((noteText).value = $event)),
            class: "note-section__textarea",
            placeholder: "Enter here",
            rows: "5"
          }, null, 512), [
            [_vModelText, noteText.value]
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createVNode(_unref(Button), {
              variant: "secondary",
              size: "sm",
              icon: "mdi:calendar-clock",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (showRescheduleMeetingModal.value = true))
            }, {
              default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                _createTextVNode(" Reschedule ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              variant: "primary",
              size: "sm",
              loading: isRegisteringNote.value,
              disabled: !noteText.value?.trim(),
              onClick: handleRegisterNote
            }, {
              default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                _createTextVNode(" Save Note ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_61, [
        _createVNode(_unref(Button), {
          variant: "secondary",
          block: "",
          loading: 
            isUpdatingStatus.value &&
            (updatingStatusType.value === _unref(MeetingStatuses).noShow ||
              (isNoShow.value && updatingStatusType.value === _unref(MeetingStatuses).pending))
          ,
          disabled: isUpdatingStatus.value,
          class: _normalizeClass(['btn-no-show', { 'is-filled': isNoShow.value }]),
          onClick: handleNoShow
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Icon), {
              icon: isNoShow.value ? 'mdi:undo-variant' : meetingStatusIcons[_unref(MeetingStatuses).noShow],
              class: "btn-status-icon"
            }, null, 8, ["icon"]),
            _createTextVNode(" " + _toDisplayString(isNoShow.value ? "Undo No Show" : "No Show"), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "class"]),
        _createVNode(_unref(Button), {
          variant: "secondary",
          block: "",
          loading: 
            isUpdatingStatus.value &&
            (updatingStatusType.value === _unref(MeetingStatuses).meetingHeld ||
              (isMeetingHeld.value && updatingStatusType.value === _unref(MeetingStatuses).pending))
          ,
          disabled: isUpdatingStatus.value,
          class: _normalizeClass(['btn-meeting-held', { 'is-filled': isMeetingHeld.value }]),
          onClick: handleMeetingHeld
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Icon), {
              icon: meetingStatusIcons[_unref(MeetingStatuses).meetingHeld],
              class: "btn-status-icon"
            }, null, 8, ["icon"]),
            _cache[52] || (_cache[52] = _createTextVNode(" Meeting Held ", -1))
          ]),
          _: 1
        }, 8, ["loading", "disabled", "class"])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})